/** Landing hero CTA → dashboard free editor. */

export const LANDING_HANDOFF_FROM = "landing";
export const LANDING_HANDOFF_INTENT = "create_pfp";
export const LANDING_TRAY_SESSION_KEY = "pfp_landing_free_tray";
export const P3M_PREDICT_ORIGIN = "https://api.pfpmaker.com";

export type LandingDemoId = 1 | 2 | 3;

export function isLandingCreatePfp(params: {
  from?: string | null;
  intent?: string | null;
}): boolean {
  return params.from === LANDING_HANDOFF_FROM && params.intent === LANDING_HANDOFF_INTENT;
}

export function parseLandingDemoId(value: string | null | undefined): LandingDemoId | null {
  if (value === "1" || value === "2" || value === "3") return Number(value) as LandingDemoId;
  return null;
}

export function landingDemoSrc(id: LandingDemoId): string {
  return `/assets/free-pfp/demo-pic-${id}.png`;
}

export function isAllowedPpUid(id: string): boolean {
  return /^[A-Za-z0-9_-]{8,80}$/.test(id);
}

export function isAllowedP3mPollUrl(url: string): boolean {
  try {
    const parsed = new URL(url);
    if (parsed.protocol !== "https:") return false;
    if (parsed.hostname !== "api.pfpmaker.com") return false;
    return /^\/v3\/predictions\/[A-Za-z0-9_-]{8,80}\/?$/.test(parsed.pathname);
  } catch {
    return false;
  }
}

export function ppUidFromPollUrl(url: string): string | null {
  const match = url.match(/\/v3\/predictions\/([A-Za-z0-9_-]{8,80})\/?$/);
  return match?.[1] ?? null;
}

export function p3mPollUrlFromUid(ppUid: string): string {
  return `${P3M_PREDICT_ORIGIN}/v3/predictions/${encodeURIComponent(ppUid)}/`;
}

/** Upload POST only. Demo URLs never carry a job id. */
export function parseLandingPpUid(params: {
  ppUid?: string | null;
  pollUrl?: string | null;
}): string | null {
  if (params.ppUid && isAllowedPpUid(params.ppUid)) return params.ppUid;
  if (params.pollUrl) {
    const fromUrl = ppUidFromPollUrl(params.pollUrl);
    if (fromUrl && isAllowedPpUid(fromUrl)) return fromUrl;
  }
  return null;
}
